/** @format */
import React from "react";
import { observer } from "mobx-react";
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Box,
  Text
} from "@chakra-ui/react";
import {
  Flex,
  Image,
  Link,
  Button,
  Stack,
  useDisclosure
} from "@chakra-ui/react";
import { commonInfo } from "@common/index";
import { useStores } from "@src/hooks/useStores";
import colors from "@src/style/colors";
import { Language } from "@src/stores/Settings";
import { useNavigate } from "react-router-dom";
import style from "./navbar.module.css";

export const Sidebar: React.FC = observer(() => {
  const { settings } = useStores();
  const navigate = useNavigate();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();

  return (
    <Drawer
      isOpen={settings.isSidebarOpen}
      placement="right"
      onClose={() => {
        settings.setSidebar();
      }}
      finalFocusRef={btnRef}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>
          <Link>
            <Image
              height={{ base: "22px", sm: "22px" }}
              src={commonInfo.logo.sandbank.image}
              onClick={() => {
                navigate("/");
                settings.setSidebar();
              }}
            />
          </Link>
        </DrawerHeader>
        <DrawerBody mt={"20px"}>
          <Stack
            height={"100%"}
            justify={"start"}
            align={"start"}
            fontSize={"18px"}
            gap={"20px"}
            fontWeight={700}
          >
            <Link
              href={"https://medium.com/sandbank-kr"}
              _hover={{
                textDecoration: "underline",
                textDecorationThickness: "2px",
                textUnderlineOffset: "5px",
                textDecorationColor: colors.blue
              }}
              isExternal
            >
              {settings.language === Language.korean
                ? "공지사항"
                : "Announcements"}
            </Link>
            <Link
              onClick={() => {
                navigate("/about", { replace: true });
                settings.setSidebar();
              }}
              _hover={{
                textDecoration: "underline",
                textDecorationThickness: "2px",
                textUnderlineOffset: "5px",
                textDecorationColor: colors.blue
              }}
            >
              {settings.language === Language.korean ? "회사소개" : "Company"}
            </Link>
            <Link
              className={style.btn}
              _hover={{
                textDecoration: "underline",
                textDecorationThickness: "2px",
                textUnderlineOffset: "5px",
                textDecorationColor: colors.blue
              }}
              onClick={() => {
                settings.setDirectingQnA();
                settings.setSidebar();
                navigate("/");
              }}
            >
              {settings.language === Language.korean ? "자주 묻는 질문" : "FAQ"}
            </Link>
            {/* <Link
              href={"https://sandbank.oopy.io/"}
              isExternal
              _hover={{
                textDecoration: "underline",
                textDecorationThickness: "2px",
                textUnderlineOffset: "5px",
                textDecorationColor: colors.blue
              }}>
              {settings.language === Language.korean ? "채용" : "Recruit"}
            </Link> */}
            <Link
              href={"https://surf.sandbank.io"}
              isExternal
              style={{ textDecoration: "none" }}
            >
              <Image
                height={{ base: "22px", sm: "22px" }}
                src={commonInfo.logo.surf.image}
              />
            </Link>
            <Flex
              flexDirection={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              borderRadius={"1000px"}
              overflow={"hidden"}
              gap={"10px"}
            >
              <Button
                variant={"unstyled"}
                width={"50%"}
                fontSize={"18px"}
                fontWeight={settings.language === Language.korean ? 600 : 400}
                color={
                  settings.language === Language.korean
                    ? colors.black
                    : colors.coolGray200
                }
                onClick={() => {
                  settings.setLanguage(Language.korean);
                  settings.setSidebar();
                }}
              >
                <Text
                  textAlign={"start"}
                  _hover={{
                    textDecoration: "underline",
                    textDecorationThickness: "2px",
                    textUnderlineOffset: "5px",
                    textDecorationColor: colors.blue
                  }}
                >
                  KOR
                </Text>
              </Button>
              <Box
                width={"1px"}
                height={"50%"}
                backgroundColor={colors.coolGray600}
              ></Box>
              <Button
                variant={"unstyled"}
                width={"50%"}
                fontSize={"18px"}
                flexShrink={1}
                fontWeight={settings.language === Language.english ? 600 : 400}
                color={
                  settings.language === Language.english
                    ? colors.black
                    : colors.coolGray200
                }
                onClick={() => {
                  settings.setLanguage(Language.english);
                  settings.setSidebar();
                }}
              >
                <Text
                  textAlign={"end"}
                  _hover={{
                    textDecoration: "underline",
                    textDecorationThickness: "2px",
                    textUnderlineOffset: "5px",
                    textDecorationColor: colors.blue
                  }}
                >
                  ENG
                </Text>
              </Button>
            </Flex>
          </Stack>
        </DrawerBody>

        <DrawerFooter></DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
});

export default Sidebar;
